<template lang="pug">
#bloco-categoria-monitoramento-agricola
    .container-categoria.view-container
        h3 {{ texto }}
        .categoria-lista
            el-button(round)
                | Round
</template>

<script>
export default {
    name: 'BlocoCategoriaMonitoramentoAgricola',
    props: {
        texto: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
#bloco-categoria-monitoramento-agricola {
    margin-bottom: 25px;
    .container-categoria {
        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--var(--black));
            font-weight: 500;
        }
        .el-button.is-round {
            margin: 2px 3px 0px 2px;
        }
        .el-button.is-round:not(:first-child) {
            margin: 2px 3px 2px 2px;
        }
        .el-button.is-round {
            box-shadow: 0px 0px 2px 0px var(--block-shadow);
            border-radius: 20px;
            padding: 9px 20px;
            min-width: 149px;
            color: var(--primary);
        }
    }
}
</style>
